// web-v2/src/lib/producer-share.js
//
// Pure: a producer's share is a fraction 0 to 1 on the wire and a percent on the page (deals-door-1 answers round 3, R2c-Q1);
// null is "share not stated", never 100%. No store, no fetch: the deal key and the admin page both call these.

// The page's two conversions, stated once: a percent typed (blank is not stated) to the wire's fraction, and back.
export function percentToShare(text) {
  const t = String(text == null ? '' : text).trim();
  if (t === '') return { ok: true, share: null };
  if (!/^\d{1,3}(\.\d{1,4})?$/.test(t)) return { ok: false };
  const n = Number(t);
  if (n < 0 || n > 100) return { ok: false };
  return { ok: true, share: Math.round(n * 1e4) / 1e6 };
}

export function shareToPercent(share) {
  if (share === null || share === undefined) return '';
  return String(Math.round(Number(share) * 1e6) / 1e4);
}

export function shareWords(share) {
  return share === null || share === undefined ? 'share not stated' : `${shareToPercent(share)}%`;
}
